<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">
	  <ProductionOutMenu></ProductionOutMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-12 col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Kontrahenci - zlecenia zewnętrzne</h4>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="custom-table">
            <form v-if="hasPermission('canAddOutProducent')" @submit.prevent="submitForm">
              <div class="col-md-4 col-lg-6">
                <div class="container-fluid">
                  <div class="d-flex gap-2 align-items-start">
                    <select v-model="form.customer_id" class="select2 form-select w-100" id="sel_customer_id">
                      <option value="" disabled selected>-- Wybierz kontrahenta --</option>
                      <option v-for="customer in customers" :key="customer.id" :value="customer.id">
                        {{ customer.short_name }}
                      </option>
                    </select>
                    <button type="submit" class="btn btn-primary mb-3">Dodaj</button>
                  </div>
                </div>
              </div>
            </form>
            <div class="table-responsive">
              <table id="producents-out-table" class="table table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Skrót/Nazwa</th>
                  <th>Uwagi</th>
                  <th>Jakość</th>
                  <th>Terminowść</th>
                  <th>Ceny</th>
                  <th>Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(producentsout, pid) in producents_out" :key="pid">
                  <td>{{ pid + 1 }}</td>
                  <td style="min-width:150px; max-width: 300px;">
                    <span v-if="hasPermission('canViewClients')"><a :href="`/customers/${producentsout.customer_id}`"
                                                                    target="_blank" style="cursor:pointer; color:blue;"><strong>{{
                        producentsout.customer?.short_name
                      }}</strong><br>{{ producentsout.customer?.name }}</a></span>
                    <span v-else><strong>{{
                        producentsout.customer?.short_name
                      }}</strong><br>{{ producentsout.customer?.name }}</span>
                    <div class="mt-1">
						<span v-for="n in 5" :key="n">
						  <i class="bi"
                 :class="n <= averageRating(producentsout) ? 'bi-star-fill text-primary' : 'bi-star text-muted'"></i>
						</span> ({{ averageRating2(producentsout) }})
                    </div>
                  </td>
                  <td v-if="hasPermission('canAddOutProducent')" @click="openEditModal('uwagi', producentsout)"
                      style="cursor:pointer; min-width:250px; max-width: 300px;">
                    <span>{{ producentsout.uwagi }}</span>
                  </td>
                  <td v-else style="min-width:250px; max-width: 300px;">
                    <span>{{ producentsout.uwagi }}</span>
                  </td>
                  <td v-if="hasPermission('canAddOutProducent')" @click="openEditModal('jakosc', producentsout)"
                      style="cursor:pointer; min-width:250px; max-width: 300px;">
                    <span>{{ producentsout.jakosc }}</span>
                    <br>
                    <div>
					    <span v-for="n in 5" :key="n">
						  <i class="bi" :class="n <= producentsout.ocena1 ? 'bi-star-fill text-warning' : 'bi-star text-muted'"></i>
					    </span>
                    </div>
                  </td>
                  <td v-else style="min-width:250px; max-width: 300px;">
                    <span>{{ producentsout.jakosc }}</span>
                    <br>
                    <div>
					    <span v-for="n in 5" :key="n">
						  <i class="bi" :class="n <= producentsout.ocena1 ? 'bi-star-fill text-warning' : 'bi-star text-muted'"></i>
					    </span>
                    </div>
                  </td>
                  <td v-if="hasPermission('canAddOutProducent')" @click="openEditModal('terminowosc', producentsout)"
                      style="cursor:pointer; min-width:250px; max-width: 300px;">
                    <span>{{ producentsout.terminowosc }}</span>
                    <br>
                    <div>
					    <span v-for="n in 5" :key="n">
						  <i class="bi" :class="n <= producentsout.ocena2? 'bi-star-fill text-warning' : 'bi-star text-muted'"></i>
					    </span>
                    </div>
                  </td>
                  <td v-else style="min-width:250px; max-width: 300px;">
                    <span>{{ producentsout.terminowosc }}</span>
                    <br>
                    <div>
					    <span v-for="n in 5" :key="n">
						  <i class="bi" :class="n <= producentsout.ocena2? 'bi-star-fill text-warning' : 'bi-star text-muted'"></i>
					    </span>
                    </div>
                  </td>
                  <td v-if="hasPermission('canAddOutProducent')" @click="openEditModal('ceny', producentsout)"
                      style="cursor:pointer; min-width:250px; max-width: 300px;">
                    <span>{{ producentsout.ceny }}</span>
                    <br>
                    <div>
					    <span v-for="n in 5" :key="n">
						  <i class="bi" :class="n <= producentsout.ocena3? 'bi-star-fill text-warning' : 'bi-star text-muted'"></i>
					    </span>
                    </div>
                  </td>
                  <td v-else style="min-width:250px; max-width: 300px;">
                    <span>{{ producentsout.ceny }}</span>
                    <br>
                    <div>
					    <span v-for="n in 5" :key="n">
						  <i class="bi" :class="n <= producentsout.ocena3? 'bi-star-fill text-warning' : 'bi-star text-muted'"></i>
					    </span>
                    </div>
                  </td>
                  <td>
                    <a :href="route('producent.out.show', {id: producentsout.customer_id })"
                       class="btn btn-info btn-sm me-2 equal-width-btn  mt-2"><i class="bi bi-url"></i> &nbsp;Zamówienia</a>
                    <button v-if="hasPermission('canDelOutProducent')"
                            @click="deleteProducentsOut(producentsout.customer_id)" class="btn btn-sm btn-danger  mt-2">
                      <i class="bi bi-trash me-2 equal-width-btn"></i>Usuń
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div v-if="isModalOpen" class="modal fade show" tabindex="-1"
                 style="display: block; background: rgba(0,0,0,0.5);">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Edycja</h5>
                    <button type="button" class="btn-close" @click="closeModal"></button>
                  </div>
                  <div class="modal-body">
                    <div>
                      <textarea v-model="editedValue" class="form-control" rows="6"></textarea>
                      <div v-if="ratingFieldsMap[editedField]" class="mt-3">
                        <label class="form-label">Ocena (1–5):</label>
                        <div class="d-flex gap-2">
                          <label v-for="n in 5" :key="n" class="form-check-label">
                            <input type="radio" class="form-check-input" :value="n" v-model="editedRating"/>
                            {{ n }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-danger" @click="closeModal">Anuluj</button>
                    <button type="button" class="btn btn-primary" @click="saveEditedValue">Zapisz</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import {useForm} from "@inertiajs/vue3";
import {Tooltip} from 'bootstrap';
import {isDisabled} from "bootstrap/js/src/util/index.js";
import ProductionOutMenu from "@/Pages/ProductionOut/parts/ProductionOutMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, hasPermission, ProductionOutMenu},
  props: {
    producents_out: Array,
    customers: {
      type: Array,
      default: () => []
    },
  },

  data() {
    return {
      hasPermission,
      isModalOpen: false,
      editedValue: '',
      editedField: '',
      editingItem: null,
      form: {
        customer_id: '',
        uwagi: '',
        jakosc: '',
        terminowosc: '',
        ceny: ''
      },
      ratingFieldsMap: {
        jakosc: 'ocena1',
        terminowosc: 'ocena2',
        ceny: 'ocena3'
      },
      editedRating: null,
    };
  },
  mounted() {
    this.handleSelect2();
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    });
  },

  methods: {
    averageRating(item) {
      const ratings = [item.ocena1, item.ocena2, item.ocena3].map(Number).filter(n => !isNaN(n));
      if (!ratings.length) return 0;
      const avg = ratings.reduce((a, b) => a + b, 0) / ratings.length;
      return Math.round(avg);
    },
    averageRating2(item) {
      const ratings = [item.ocena1, item.ocena2, item.ocena3]
          .map(Number)
          .filter(n => !isNaN(n));
      if (!ratings.length) return 0;

      const avg = ratings.reduce((a, b) => a + b, 0) / ratings.length;
      return parseFloat(avg.toFixed(1));
    },

    openEditModal(field, item) {
      this.editedField = field;
      this.editedValue = item[field];
      this.editingItem = item;
      const ratingField = this.ratingFieldsMap[field];
      this.editedRating = ratingField ? Number(item[ratingField]) : null;
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.editedValue = '';
      this.editedRating = null;
      this.editingItem = null;
    },
    handleSelect2() {
      $('#sel_customer_id').select2().on('select2:select', (e) => {
        this.form.customer_id = parseInt(e.params.data.id);
      });
    },

    formatDate(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return date.toISOString().split('T')[0];
    },

    getEmptyForm() {
      return {
        customer_id: '',
        uwagi: '',
        jakosc: '',
        terminowosc: '',
        ceny: ''
      };
    },
    editProducentsOut(id) {
      this.editingId = id;
    },

    saveEditedValue() {
      if (this.editingItem && this.editedField) {
        const payload = {
          [this.editedField]: this.editedValue
        };

        const ratingField = this.ratingFieldsMap[this.editedField];
        if (ratingField && this.editedRating != null) {
          payload[ratingField] = Number(this.editedRating);
        }

        this.updateSingleField(this.editingItem.id, payload);
      }
      this.closeModal();
    },

    updateSingleField(id, payload) {
      this.$inertia.put(route('producents.out.update', id), payload, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },

    submitForm() {
      this.$inertia.post(route('producents.out.store'), this.form, {
        onSuccess: () => {
          this.form = this.getEmptyForm();
          $('#sel_customer_id').val(null).trigger('change');
        }
      });
    },

    deleteProducentsOut(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie kontrahenta',
        html: 'Czy na pewno chcesz usunąć wybranego kontrahenta z listy oraz zamówień zewnętrznych?',
        showDenyButton: true,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('producents.out.destroy', id));
        }
      })
    }
  }
}
</script>
<style scoped>
.tooltip {
  opacity: 1 !important;
}

.bi-star, .bi-star-fill {
  font-size: 1.2rem;
}
</style>
